export default __webpack_public_path__ + "static/media/viber.23be65e1.svg";